import { action, makeAutoObservable, observable } from "mobx"
import importJobLogService from "@services/common/importJobLogService"
import type { ImportJobLogItem } from "@services/common/importJobLogService"
import type { PagedResultDto } from "@services/dto/pagedResultDto"

class ImportJobLogStore {
  @observable isLoading: boolean = false
  @observable tableData: PagedResultDto<ImportJobLogItem> = { items: [], totalCount: 0 }

  constructor() {
    makeAutoObservable(this)
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await importJobLogService
      .getAll(params)
      .finally(() => (this.isLoading = false))
    this.tableData = result
  }

  @action
  async downloadOutputFile(jobLogId: number) {
    await importJobLogService.downloadOutputFile(jobLogId)
  }
}

export default ImportJobLogStore
